import { useState, useMemo } from 'react';
import { Button } from 'antd';
import { getWeekStart, getWeekRangeDisplay, addDays, formatDate, getDayDisplay, getWeekRangeDisplayByString } from './util';
import {
    Calendar,
} from 'lucide-react';

interface IProps{
    dates: API.WorktimeDaily.date[],
    isAll: boolean,
    pageType: string,
    currentDate: string,
    onChangeDate: (date: string, isAll: boolean) => void,
    onAudit: (type: string) => void,
}
export default function AuditFilter(props: IProps) {

    const filterDates = useMemo(() => {
        if (!props.dates || props.dates.length === 0) return {
            weekRange: "",
            dates: [],
        }
        const allDates = props.dates.map((date) => {
            return {
                dayLabel: getDayDisplay(date.spentOn),
                ...date,
            }
        })
        const firstDate = allDates[0].spentOn
        const lastDate = allDates[allDates.length - 1].spentOn
        const weekRange = getWeekRangeDisplayByString(firstDate, lastDate)
        return {
            weekRange: weekRange,
            dates: allDates,
        }
    }, [props.dates])

    // 是否显示全部审批按钮
    const hasAllApprove = useMemo(() => {
        const dates = props.dates || []
        let hasBtn = false
        dates.forEach(v => {
            let status = v.status

            if (status === 0 || status === 2) {
                hasBtn = true
            }
        })
        return hasBtn
    }, [props.dates])

    const isAllApprove = useMemo(() => {
        const dates = props.dates || []
        let isApprove = true
        dates.forEach(v => {
            let status = v.status
            if (status === 0 || status === 2) {
                isApprove = false
            }
        })
        return isApprove
    }, [props.dates])

    const onChangeDayDate = (date: API.WorktimeDaily.date) => {
        if(date.status === -1) return
        props.onChangeDate(date.spentOn, false)
    }

    const renderAction = () => {
        if (!hasAllApprove) return null
        if (props.isAll && hasAllApprove) {
            return (<Button className="ml-2" type="primary" onClick={() => props.onAudit(props.pageType)}>全部审批</Button>)
        }
        if (!props.isAll && props.currentDate) {
            const date = props.dates.find(v => v.spentOn === props.currentDate)
            if (!date) return null
            let status = date.status
            if (status === 0) {
                return (<Button className="ml-2" type="primary" onClick={() => props.onAudit(props.pageType)}>审批</Button>)
            }
            if (status === 2) {
                return (<Button className="ml-2" type="primary" onClick={() => props.onAudit(props.pageType)}>更新审批</Button>)
            }
        }
        return <span className="text-slate-500 ml-2">已审批</span>
    }

    const allDayItemCls = () => {
        if (hasAllApprove) return props.isAll ? "text-red-500 shadow-sm bg-white" : "text-red-500 hover:text-red-600 hover:bg-white/80"
        return props.isAll ? 'bg-white text-blue-700 shadow-sm' : 'text-slate-600 hover:text-slate-900 hover:bg-white/80'
    }
    const dayItemCls = (isActive: boolean, isWarn: boolean, isDisabled: boolean) => {
        if (isDisabled) return "text-slate-400 cursor-not-allowed"
        if (isWarn) return isActive ? "text-red-500 bg-white shadow-sm cursor-pointer" : "text-red-500 hover:text-red-600 hover:bg-white/80 cursor-pointer"
        return isActive ? "bg-white text-blue-700 shadow-sm bg-white cursor-pointer" : "text-slate-600 hover:text-slate-900 hover:bg-white/80 cursor-pointer"
    }

    return (

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-4 flex flex-col space-y-4" >

            {/* Week & Date Navigation */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between" >
                
                

                <div className="flex bg-slate-100 p-1 rounded-lg overflow-x-auto w-full md:w-auto mt-4 md:mt-0">
                    <div
                        onClick={() => props.onChangeDate(props.currentDate, true)}
                        className={`cursor-pointer shrink-0 px-4 py-1.5 text-sm font-medium rounded-md transition-colors 
                            ${allDayItemCls()}
                        `}
                    >
                        整周汇总
                        {isAllApprove && (
                            <div className="text-slate-500 text-xs text-center font-normal">已审批</div>
                        )}
                    </div>
                    {filterDates.dates.map(date => {
                        let status = date.status
                        // if (props.pageType === "sz") {
                        //     status = date.paStatus
                        // } else if (props.pageType === "zc") {
                        //     status = date.status
                        // }
                        const isWarn = status === 0 || status === 2
                        const isActive = props.currentDate === date.spentOn && !props.isAll
                        const isDisabled = status === -1
                        return (
                            <div
                                key={date.spentOn}
                                onClick={() => onChangeDayDate(date)}
                                className={`shrink-0 px-4 py-1.5 text-sm font-medium rounded-md transition-colors 
                                    ${dayItemCls(isActive, isWarn, isDisabled)}
                                `}
                            >
                                {date.dayLabel}
                                {isWarn && (
                                    <div className="text-slate-500 text-xs text-center font-normal">{date.status === 0 ? '待审批' : date.status === 2 ? '待更新审批' : '已审批'}</div>
                                )}
                                {status === 1 && (
                                    <div className="text-slate-500 text-xs text-center font-normal">已审批</div>
                                )}
                            </div>
                        );
                    })}
                </div>
                {renderAction()}
            </div>
        </div>
    )
    
}
